import { Routes } from '@angular/router';
import { AuthGuard } from '@guards/auth.guard';
import { AdvancecustomizeGuard } from '@guards/can-advancecustomize.guard';
import { CanCustomizeGuard } from '@guards/can-customize.guard';
import { IsAdminGuard } from '@guards/isAdmin.guard';
import { UrlConstants } from '@shared/url-constants';

export const routes: Routes = [
	{
		path: '',
		data: {
			breadcrumb: 'BREADCRUMBS.HOME',
		},
		children: [
			{
				path: 'login',
				loadComponent: () =>
					import('@app/login/login').then(
						(c) => c.LoginPageComponent
					),
			},
			{
				path: '',
				redirectTo: '/titanium',
				pathMatch: 'full',
			},
			{
				path: 'titanium',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.TITANIUM',
				},
				loadComponent: () =>
					import('@app/home/home').then((c) => c.HomePageComponent),
			},
			{
				path: 'precious',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.PRECIOUS',
				},
				loadComponent: () =>
					import('@app/home/home').then((c) => c.HomePageComponent),
			},
			{
				path: 'inspiration',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.INSPIRATION',
				},
				loadComponent: () =>
					import('@app/home/home').then((c) => c.HomePageComponent),
			},
			{
				path: 'tools',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.TOOLS',
				},
				loadComponent: () =>
					import('@app/home/home').then((c) => c.HomePageComponent),
			},
			{
				path: 'seasonal',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.SEASONALFOCUS',
				},
				loadComponent: () =>
					import('@app/home/home').then((c) => c.HomePageComponent),
			},
			{
				path: 'discontinued-items',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'discontinued items',
				},
				loadComponent: () =>
					import('@app/discontinued-items/discontinued-items.component').then(
						(c) => c.DiscontinuedItemsComponent
					),
			},
			{
				path: 'search',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.SEARCH',
				},
				loadComponent: () =>
					import('@app/search/search.component').then(
						(c) => c.SearchComponent
					),
			},
			{
				path: 'search/:searchterm',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.SEARCH',
				},
				loadComponent: () =>
					import('@app/search/search.component').then(
						(c) => c.SearchComponent
					),
			},
			{
				path: 'filter',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.filter',
				},
				loadComponent: () =>
					import(
						'@app/filters/filter-selector/filter.component'
					).then((c) => c.FilterComponent),
			},
			{
				path: 'filterlist',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.FILTERLIST',
				},
				loadComponent: () =>
					import('@app/filters/filter-result/filter-list').then(
						(c) => c.FilterListPageComponent
					),
			},
			{
				path: 'customer',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.CUSTOMER-SELECTOR',
				},
				loadComponent: () =>
					import(
						'@app/customer-selector/customer-selector.component'
					).then((c) => c.CustomerSelectorComponent),
			},
			{
				path: 'orderconfirmation/:userUuid/:orderUuid/:customerNo',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'HOME.ORDER',
				},

				loadChildren: () =>
					import('@app/bag/bag.routes').then((c) => c.bagRoutes),
			},
			{
				path: 'ordersummary/:userUuid/:orderUuid/:customerNo',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'HOME.ORDER',
				},

				loadChildren: () =>
					import('@app/bag/bag.routes').then((c) => c.bagRoutes),
			},
			{
				path: `searchresults/:${UrlConstants.MODEL}`,
				canActivate: [AdvancecustomizeGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.SEARCHRESULTS',
				},

				loadComponent: () =>
					import(
						'@app/condensed-customizer/condensed-customizer/condensed-customizer'
					).then((c) => c.CondensedCustomizerPageComponent),
			},
			{
				path: 'featured/:' + UrlConstants.INSPIRATIONGROUP,
				canActivate: [AuthGuard],
				data: {
					breadcrumb: ':' + UrlConstants.INSPIRATIONGROUP,
				},
				loadChildren: () =>
					import('@app/featured/featured.routes').then(
						(c) => c.featuredRoutes
					),
			},
			{
				path: UrlConstants.KIDTEEN,
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.KIDTEEN',
				},
				loadComponent: () =>
					import('@app/kid-teen/kidteen').then(
						(c) => c.KidTeenPageComponent
					),
				pathMatch: 'full',

				children: [
					{
						path: 'productline/:productLine',
						canActivate: [AuthGuard, CanCustomizeGuard],
						data: {
							breadcrumb: ':' + UrlConstants.MODEL,
						},
						loadComponent: () =>
							import(
								'@app/home/product-lines/product-line-model-groups-models.component'
							).then(
								(c) => c.ProductLineModelGroupsModelsComponent
							),
						children: [
							{
								pathMatch: 'full',

								path: 'model/:modelName',
								canActivate: [AuthGuard, CanCustomizeGuard],
								data: {
									breadcrumb: ':' + UrlConstants.MODEL,
								},
								loadComponent: () =>
									import('@app/customizer/customizer').then(
										(c) => c.CustomizerPageComponent
									),
							},
						],
					},
				],
			},
			{
				path: UrlConstants.SPECIAL_EDITION,
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.SPECIAL_EDITION',
				},
				loadComponent: () =>
					import('@app/Special-Edition/Special-Edition').then(
						(c) => c.SpecialEditionPageComponent
					),
				pathMatch: 'full',
				children: [
					{
						path: 'productline/:productLine',
						canActivate: [AuthGuard, CanCustomizeGuard],
						data: {
							breadcrumb: ':' + UrlConstants.MODEL,
						},
						loadComponent: () =>
							import(
								'@app/home/product-lines/product-line-model-groups-models.component'
							).then(
								(c) => c.ProductLineModelGroupsModelsComponent
							),
						children: [
							{
								pathMatch: 'full',
								path: 'model/:modelName',
								canActivate: [AuthGuard, CanCustomizeGuard],
								data: {
									breadcrumb: ':' + UrlConstants.MODEL,
								},
								loadComponent: () =>
									import('@app/customizer/customizer').then(
										(c) => c.CustomizerPageComponent
									),
							},
						],
					},
				],
			},
			{
				path: UrlConstants.LIMITED_EDITION_CNY_GOAT,
				redirectTo: '/precious/productline/strip/Limited',
				pathMatch: 'full',
			},

			{
				path: ':brandMode/productline/:productLine',
				canActivate: [AuthGuard],
				data: {
					brandMode: ':' + UrlConstants.BRANDMODE,
					breadcrumb: ':' + UrlConstants.PRODUCTLINE,
				},
				loadComponent: () =>
					import(
						'@app/home/product-lines/product-line-model-groups-models.component'
					).then((c) => c.ProductLineModelGroupsModelsComponent),
			},
			{
				path: ':brandMode/productline/:productLine/model/:modelName',
				canActivate: [AuthGuard, CanCustomizeGuard],
				data: {
					brandMode: ':' + UrlConstants.BRANDMODE,
					breadcrumb:
						':' +
						UrlConstants.PRODUCTLINE +
						':' +
						UrlConstants.MODEL,
				},

				loadComponent: () =>
					import('@app/customizer/customizer').then(
						(c) => c.CustomizerPageComponent
					),
			},
			{
				path: 'tools/:categoryCode',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: ':categoryCode',
				},
				loadComponent: () =>
					import('@app/misc/misc-group/misc-group.component').then(
						(c) => c.MiscGroupPageComponent
					),
				children: [
					{
						path: 'group/:groupCode',
						data: {
							breadcrumb: ':groupCode',
						},
						loadComponent: () =>
							import(
								'@app/misc/misc-group/misc-group.component'
							).then((c) => c.MiscGroupPageComponent),
					},
				],
			},
			{
				path: 'limited',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.LIMITED',
				},
				loadComponent: () =>
					import(
						'@app/limited/limited-list/limited-list.component'
					).then((c) => c.LimitedListComponent),
			},
			{
				path: 'parts',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.PARTS',
				},
				loadComponent: () =>
					import('@app/parts/parts.component').then(
						(c) => c.PartsComponent
					),
			},
			{
				path: 'parts/model',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.PARTS',
				},
				loadComponent: () =>
					import(
						'@app/parts/model-viewer/model-viewer.component'
					).then((c) => c.ModelViewerComponent),
			},
			{
				path: 'bag',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.BAG',
				},
				loadChildren: () =>
					import('@app/bag/bag.routes').then((c) => c.bagRoutes),
			},
			{
				path: 'technical-info',
				canActivate: [AuthGuard],
				loadComponent: () => import('@app/technical-info/frontpage/frontpage.component').then((c) => c.FrontpageComponent)
			},
			{
				path: 'technical-info/p/:id',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'technical info',
				},
				loadComponent: () => import('@app/technical-info/productline/productline.component').then(c => c.ProductlineComponent)
			},
			{
				path: 'technical-info/p/:productLine/media/:mediaId',
				canActivate: [AuthGuard],
				data: {
					breadcrumb: 'technical info',
				},
				loadComponent: () => import('@app/technical-info/video/video.component').then(c => c.VideoComponent)
			},
			{
				path: 'technical-info/m/:id',
				canActivate: [AuthGuard],
				loadComponent: () => import('@app/technical-info/model/model.component').then(c => c.ModelComponent)
			},
			{
				path: 'technical-info/formers',
				canActivate: [AuthGuard],
				loadComponent: () => import('@app/technical-info/formers/formers.component').then(c => c.FormersComponent)
			},
			{
				path: 'interior-design',
				canActivate: [AuthGuard],
				loadComponent: () => import('@app/interior-design/interior-design.component').then((c) => c.InteriorDesignComponent)
			},
			{
				path: 'certified-labs',
				canActivate: [AuthGuard],
				loadComponent: () => import('@app/certified-labs/certified-labs.component').then((c) => c.CertifiedLabsComponent)
			},
			{
				path: 'administration',
				canActivate: [AuthGuard, IsAdminGuard],
				data: {
					breadcrumb: 'BREADCRUMBS.ADMINISTRATION',
				},
				loadComponent: () =>
					import(
						'@app/administration/service-settings/service-settings.component'
					).then((c) => c.ServiceSettingsComponent),
			},
		],
	},
	{
		path: '**',
		data: {
			breadcrumb: 'BREADCRUMBS.NOTFOUND',
		},
		loadChildren: () =>
			import('@app/not-found/not-found.routes').then(
				(c) => c.notFoundRoutes
			),
	},
];
